import renewalConstants from "./renewalConstants";
import { call } from "../dashboard/service";

export default {
  namespaced: true,

  state: {
    studentUnits: [],
    studentProgrammes: [],
    registrationDocument: "",
    regions: [],
    setupProgrammes: [],
    countries: [],
    examCenters: [],
    postalCodes: [],
    semesters: [],
    programmeStages: [],
    studentTypes: [],
    examTimetable: [],
    renewals: [],
    renewal_document: "",
    receipt: "",
    // examBookings: [],
    batchRenewal: [],
    currency: "KES",
    openBatchReceiptsDialog: false,
    openIvoiceDialog: false,
  },
  mutations: {
    SET_STUDENT_PROGRAMMES: (state, payload) => {
      state.studentProgrammes = payload;
    },
    SET_REGISTRATION_DOCUMENT: (state, payload) => {
      state.registrationDocument = payload;
    },
    SET_STUDENT_UNITS: (state, payload) => {
      state.studentUnits = payload;
    },
    SET_SETUP_PROGRAMMES: (state, payload) => {
      state.setupProgrammes = payload;
    },
    SET_EXAM_CENTERS: (state, payload) => {
      state.examCenters = payload;
    },
    SET_POSTALCODES: (state, payload) => {
      state.postalCodes = payload;
    },
    SET_REGIONS: (state, payload) => {
      state.regions = payload;
    },
    SET_COUNTRIES: (state, payload) => {
      state.countries = payload;
    },
    SET_SEMESTERS: (state, payload) => {
      state.semesters = payload;
    },
    SET_PROGRAMME_STAGES: (state, payload) => {
      state.programmeStages = payload;
    },
    SET_STUDENT_TYPES: (state, payload) => {
      state.studentTypes = payload;
    },
    SET_EXAM_TIMETABLE: (state, payload) => {
      state.examTimetable = payload;
    },
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },

  getters: {
    // charges: (state) => state.charges,
    studentUnits: (state) => state.studentUnits,
    studentProgrammes: (state) => state.studentProgrammes,
    currentProgramme: (state) =>
      state.studentProgrammes.filter((p) => p.current),
    setupProgrammes: (state) => state.setupProgrammes,
    registrationDocument: (state) => state.registrationDocument,
    examCenters: (state) => state.examCenters,
    regions: (state) => state.regions,
    countries: (state) => state.countries,
    postalCodes: (state) => state.postalCodes,
    semesters: (state) => state.semesters,
    programmeStages: (state) => state.programmeStages,
    studentTypes: (state) => state.studentTypes,
    examTimetable: (state) => state.examTimetable,
    renewalGetters: (state) => (val) => state[val],
  },

  actions: {
    getExamTimeTable: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", renewalConstants.examTimetable).then((res) => {
        commit("SET_EXAM_TIMETABLE", res.data.data);
        commit("Dashboard/SET_LOADING", false, { root: true });
      });
    },
    getStudentStypes: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", renewalConstants.studentTypes).then((res) => {
        commit("SET_STUDENT_TYPES", res.data.data);
        commit("Dashboard/SET_LOADING", false, { root: true });
      });
    },
    getprogrammeStages: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", renewalConstants.programmeStages).then((res) => {
        commit("SET_PROGRAMME_STAGES", res.data.data);
        commit("Dashboard/SET_LOADING", false, { root: true });
      });
    },
    getSemesters: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", renewalConstants.semesters).then((res) => {
        commit("SET_SEMESTERS", res.data.data);
        commit("Dashboard/SET_LOADING", false, { root: true });
      });
    },
    getStudentUnits: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", renewalConstants.studentUnits).then((res) => {
        commit("SET_STUDENT_UNITS", res.data.data);
        commit("Dashboard/SET_LOADING", false, { root: true });
      });
    },
    getStudentProgrammes: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", renewalConstants.getRegistrations).then((res) => {
        commit("SET_STUDENT_PROGRAMMES", res.data.data);
        commit("Dashboard/SET_LOADING", false, { root: true });
      });
    },
    getSetupProgrammes: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", renewalConstants.setupProgrammes).then((res) => {
        commit("SET_SETUP_PROGRAMMES", res.data.data);
        commit("Dashboard/SET_LOADING", false, { root: true });
      });
    },
    submitRegistration: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", renewalConstants.postRegistration, data)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", res.data.message);
          Event.$emit("refetch", "Renewal/getStudentProgrammes");
          Event.$emit("route-change", { name: "RegistrationList" });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    submitRegistrationUnits: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("patch", renewalConstants.patchRegistration, data)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", `${res.data.message} Proceed to payment`);
          Event.$emit("proceed-payment");
          Event.$emit("refetch", "Renewal/getStudentProgrammes");
          // Event.$emit("route-change", { name: "RegistrationList" });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getRegistrationDocument: ({ commit }, regNo) => {
      call("get", renewalConstants.registrationDocument(regNo)).then((res) => {
        commit(
          "SET_REGISTRATION_DOCUMENT",
          process.env.VUE_APP_TEMP_URL + res.data.data[0],
        );
        commit("Dashboard/SET_LOADING", false, { root: true });
      });
    },
    getExamCenters: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", renewalConstants.examCenters).then((res) => {
        commit("SET_EXAM_CENTERS", res.data.data);
        commit("Dashboard/SET_LOADING", false, { root: true });
      });
    },
    getCountries: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", renewalConstants.countries).then((res) => {
        commit("SET_COUNTRIES", res.data.data);
        commit("Dashboard/SET_LOADING", false, { root: true });
      });
    },
    getRegions: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", renewalConstants.regions).then((res) => {
        commit("SET_REGIONS", res.data.data);
        commit("Dashboard/SET_LOADING", false, { root: true });
      });
    },
    getPostalCodes: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", renewalConstants.postalCodes).then((res) => {
        commit("SET_POSTALCODES", res.data.data);
        commit("Dashboard/SET_LOADING", false, { root: true });
      });
    },
    getRenewals: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", renewalConstants.RENEWALS)
        .then((res) => {
          const batchRenewal = res?.data?.data?.filter(
            (renewal) => renewal.billed && !renewal.paid,
          );
          commit("MUTATE", { state: "renewals", data: res.data.data });
          commit("MUTATE", { state: "batchRenewal", data: batchRenewal });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getRenewalProforma: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", renewalConstants.RENEWAL_PROFORMA(payload))
        .then((res) => {
          commit("MUTATE", {
            state: "renewal_document",
            data: process.env.VUE_APP_TEMP_URL + res.data.data,
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getRenewalReceipt({ commit }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", renewalConstants.receipt(payload))
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "receipt",
            data: process.env.VUE_APP_TEMP_URL + res.data.data[0],
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
  },
};
